<template>
  <el-config-provider :locale="locale">
    <router-view/>
  </el-config-provider>
</template>

<script setup>
import { computed, ref } from 'vue'

// locale  持久化配置
const language = ref('')
const locale = computed(() => {
  // console.log(language.value)
  language.value === 'zhCN' ? 'en' : 'zhCN'
})

const toggle = () => {
  language.value = language.value === 'zhCN' ? 'en' : 'zhCN'
}
</script>

<style lang="scss">
#app {
  font-family: 'PingFang SC-Regular', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.bg-red{
  background-color: #DF0913;
}

// 全局移动端优化
* {
  box-sizing: border-box;
}

img {
  max-width: 100%;
  height: auto;
}

// Element Plus 对话框移动端优化
:deep(.el-dialog) {
  @media (max-width: 767px) {
    margin: 5vh auto !important;
    width: 90% !important;
  }
}

:deep(.el-dialog__body) {
  @media (max-width: 767px) {
    padding: 15px !important;
  }
}

// 确保表格在移动端可以横向滚动
:deep(.el-table) {
  @media (max-width: 767px) {
    overflow-x: auto;
  }
}

// 表单在移动端的优化
:deep(.el-form-item__label) {
  @media (max-width: 767px) {
    font-size: 14px;
  }
}

:deep(.el-input__inner),
:deep(.el-textarea__inner) {
  @media (max-width: 767px) {
    font-size: 14px;
  }
}
</style>
